;(function () {
  'use strict';

  const angular = window.angular;

  ProjectFormController.$inject = ['$scope', 'ProjectService', 'Customer', 'AppUtils', 'LocalStorageService'];

  angular
    .module('app')
    .component('projectForm', {
      template:'<form name="$ctrl.projectForm" class="validate" novalidate ng-show="!$ctrl.saving"><div class="modal-header"><button type="button" class="close" ng-click="$ctrl.modalInstance.dismiss()"><i class="fas fa-times"></i></button> <span translate>{{::($ctrl.project.id? \'buttons.edit\': \'buttons.create\')}}</span> <span translate>entities.project.modelName</span></div><div class="modal-body paddingB0"><div class="form-group" show-errors><label class="control-label" for="name-input" translate>entities._all.name</label> <input id="name-input" name="nameInput" ng-model="$ctrl.project.name" translate-attr="::{placeholder: \'entities._all.name\'}" class="form-control" required><p class="help-block" ng-messages="$ctrl.projectForm.nameInput.$error"><span ng-message="required">You did not enter a field</span></p></div><div class="form-group"><label translate>entities.project.toolkit</label><div><ui-select ng-disabled="$ctrl.project.id" ng-model="$ctrl.project.toolkitId" required theme="select2"><ui-select-match placeholder="{{::\'entities.project.toolkit\' | translate}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="type.id as type in $ctrl.toolkits | filter: {name: $select.search}"><span>{{type.name}}</span></ui-select-choices></ui-select></div></div><div class="form-group"><label class="control-label" for="description-input" translate>entities._all.description</label> <textarea id="description-input" name="description-input" translate-attr="::{placeholder: \'entities._all.description\'}" maxlength="10000" simplemde="$ctrl.mdeOptions" ng-model="$ctrl.project.description" class="form-control input-sm"></textarea></div></div><div class="alert alert-warning no-margin text-center" ng-show="$ctrl.saveError">{{$ctrl.saveError}}</div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" ng-click="$ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button class="btn btn-primary" ng-click="$ctrl.saveProject()" translate>{{::($ctrl.project.id? \'buttons.edit\': \'buttons.create\')}}</button></div></form><div style="position: relative; height: 311px" ng-show="$ctrl.saving"><spinner css-class="\'small\'" show-logo="true" show="$ctrl.saving"></spinner></div>',
      controller: ProjectFormController,
      bindings: {
        modalInstance: '<',
        resolve: '<',
      },
    });

  function ProjectFormController($scope, ProjectService, Customer, utils, LocalStorageService) {
    let vm = this;

    vm.$onInit = function () {
      vm.project = angular.copy(vm.resolve.project || {});

      vm.customer = vm.resolve.customer;
      vm.saveProject = saveProject;

      vm.mdeOptions = {
        spellChecker: false,
        toolbar: [
          'bold', 'italic', 'heading', '|',
          'unordered-list', 'ordered-list', '|',
          'quote', 'link', 'table', 'code', '|',
          'preview',
        ],
      };

      Customer
        .toolkits({
          id: vm.customer.id,
        })
        .$promise
        .then(result => {
          vm.toolkits = result;
        })
        .catch(err => {
          console.log(err);
        });
    };

    function saveProject() {
      if (!vm.projectForm.$valid) {
        $scope.$broadcast('show-errors-check-validity');
        return;
      }

      if (!vm.project.toolkitId) {
        return;
      }

      vm.saving = true;

      if (vm.project.id) {
        ProjectService
          .saveProject(vm.customer.id, vm.project)
          .then(response => {
            vm.saving = false;
            LocalStorageService.clear();
            vm.modalInstance.close(response);
          })
          .catch(err => {
            console.log(err);
            vm.saveError = utils.getHTTPError(err);
            vm.saving = false;
          });
      } else {
        ProjectService
          .createProject(vm.customer.id, vm.project)
          .then(response => {
            vm.saving = false;
            LocalStorageService.clear();
            vm.modalInstance.close(response);
          })
          .catch(err => {
            console.log(err);
            vm.saveError = utils.getHTTPError(err);
            vm.saving = false;
          });
      }
    }
  }

})();
